import React from 'react';
import classes from './Toolbar.module.css';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import Avatar from '@material-ui/core/Avatar';

const Toolbar = (props) => {
    return (
        <header className={classes.Toolbar}>
            <div onClick={props.toggle} className={classes.MenuToggle}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <Logo logo={classes.Logo}/>
            <h3 style={{fontFamily:'inherit',color:'white'}}>Burger Project</h3>
            <nav className={classes.Desktop}>
                <NavigationItems shouldShowOtherLinks={props.isLoggedIn}></NavigationItems>
            </nav>
            <Avatar>ND</Avatar>
        </header>
    );
}

export default Toolbar;